import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';

// Pages
import {
  LoginPage,
  HomePage,
  VotePage,
  MagicVotePage,
  GroupVotePage,
  VoteSummaryPage,
  VoteConfirmationPage,
  VoteChoicesPage,
  AdminDashboard,
  AdminElections,
  AdminMembers,
  AdminResults,
  AdminLiveTracking,
  AdminProfile,
  AdminVoteGroups,
  IndividualVotePage,
  InitPage,
  NotFoundPage
} from './pages';

// Layout
import Layout from './components/Layout';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-gray-50">
          <Routes>
            {/* Route publique */}
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/init" element={<InitPage />} />
            <Route path="/vote/:token" element={<MagicVotePage />} />
            
            {/* Routes protégées */}
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Layout>
                  <VotePage />
                </Layout>
              </ProtectedRoute>
            } />
            
            <Route path="/vote/group/:groupId" element={
              <ProtectedRoute>
                <GroupVotePage />
              </ProtectedRoute>
            } />
            
            <Route path="/vote/individual" element={<IndividualVotePage />} />
            
            <Route path="/vote/summary/:groupId" element={
              <ProtectedRoute>
                <VoteSummaryPage />
              </ProtectedRoute>
            } />
            
            <Route path="/vote/confirmation" element={<VoteConfirmationPage />} />
            
            <Route path="/vote/choices/:groupId" element={
              <ProtectedRoute>
                <VoteChoicesPage />
              </ProtectedRoute>
            } />
            
            {/* Routes admin */}
            <Route path="/admin" element={
              <AdminRoute>
                <Layout>
                  <AdminDashboard />
                </Layout>
              </AdminRoute>
            } />
            
            <Route path="/admin/elections" element={
              <AdminRoute>
                <Layout>
                  <AdminElections />
                </Layout>
              </AdminRoute>
            } />
            
            <Route path="/admin/members" element={
              <AdminRoute>
                <Layout>
                  <AdminMembers />
                </Layout>
              </AdminRoute>
            } />
            
            <Route path="/admin/results" element={
              <AdminRoute>
                <Layout>
                  <AdminResults />
                </Layout>
              </AdminRoute>
            } />
            
            <Route path="/admin/live-tracking" element={
              <AdminRoute>
                <Layout>
                  <AdminLiveTracking />
                </Layout>
              </AdminRoute>
            } />
            
            {/* Route publique pour le suivi en temps réel */}
            <Route path="/live-tracking" element={<AdminLiveTracking />} />
            
            <Route path="/admin/profile" element={
              <AdminRoute>
                <Layout>
                  <AdminProfile />
                </Layout>
              </AdminRoute>
            } />
            
            <Route path="/admin/vote-groups" element={
              <AdminRoute>
                <Layout>
                  <AdminVoteGroups />
                </Layout>
              </AdminRoute>
            } />
            
            {/* Route 404 */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
    </div>
      </Router>
    </AuthProvider>
  );
}

export default App;